import { useEffect, useState } from 'react';
import useWebSocket from 'react-use-websocket';
// import { JsonValue } from 'react-use-websocket/dist/lib/types';
import { isEmpty } from 'lodash';
import useSocket from '../../../utils/hooks/useSocket';

const useChatSocket = () => {
  const [socketResponse, setSocketResponse] = useState(null);
  const getSocketUrl = useSocket();

  const { sendJsonMessage, lastMessage, readyState } =
    // @ts-ignore
    useWebSocket(getSocketUrl);

  const emitRequest = (jsonData: any) => {
    if (readyState === WebSocket.OPEN) {
      sendJsonMessage(jsonData);
    } else {
      console.error('WebSocket connection not open. Ready state:', readyState);
    }
  };

  useEffect(() => {
    if (!isEmpty(lastMessage?.data)) {
      const parsedData = lastMessage?.data;
      setSocketResponse(parsedData);
    }
  }, [lastMessage?.data]);
  // console.log('last message', lastMessage?.data);

  // console.log('1');

  return {
    readyState,
    socketResponse,
    emitRequest,
  };
};

export default useChatSocket;
